import { Component } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-import-smart-sms-request-from-json-dialog',
    templateUrl: 'smart-sms-import-request.html',
    styleUrls: ['smart-sms-import-request.scss'],
    standalone: false
})
  export class SmartSmsImportRequestNameDialog {
    requestName:string = '';

    requestDataForm=new FormGroup({
      "requestName":new FormControl('',Validators.required)
  });
    constructor(
        public dialogRef: MatDialogRef<SmartSmsImportRequestNameDialog>,
      ) {}

    onNoClick(): void {
        this.dialogRef.close();
      }
      
      onClose() {
        this.dialogRef.close();
      }
  }